import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Lock, Download } from 'lucide-react';
import { getCheckoutUrl, trackAddToCart } from '../utils/constants';
export function PricingSection() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const basePrice = 6.36;
  const bump1Price = 9.9;
  const bump2Price = 17.0;
  const total = basePrice + (bump1 ? bump1Price : 0) + (bump2 ? bump2Price : 0);
  const checkoutUrl = getCheckoutUrl(bump1, bump2);
  return <section id="pricing-cta" className="bg-navy text-white py-20 md:py-32 px-4" data-id="element-112">
      <div className="max-w-3xl mx-auto text-center" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-114">
          <h2 className="text-3xl md:text-5xl text-white mb-12" data-id="element-115">
            Tu Momento de Actuar es Ahora
          </h2>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 mb-12 text-left" data-id="element-116">
            <ul className="space-y-4 text-white/80 text-lg mb-8 border-b border-white/10 pb-8" data-id="element-117">
              <li className="flex justify-between" data-id="element-118">
                <span data-id="element-119">📖 Ebook Principal "Emprender con Unción"</span>{' '}
                <span data-id="element-120">$197</span>
              </li>
              <li className="flex justify-between" data-id="element-121">
                <span data-id="element-122">🎁 Bono #1: Plan de Negocios de 1 Página</span>{' '}
                <span data-id="element-123">$67</span>
              </li>
              <li className="flex justify-between" data-id="element-124">
                <span data-id="element-125">🎁 Bono #2: IA para el Reino</span> <span data-id="element-126">$47</span>
              </li>
              <li className="flex justify-between" data-id="element-127">
                <span data-id="element-128">🎁 Bono #3: Venta con Propósito</span> <span data-id="element-129">$97</span>
              </li>
            </ul>
            <div className="flex justify-between text-xl font-bold text-white/50 line-through" data-id="element-130">
              <span data-id="element-131">VALOR TOTAL:</span>
              <span data-id="element-132">$408</span>
            </div>
          </div>

          <div className="mb-10" data-id="element-133">
            <motion.div key={total.toFixed(2)} initial={{
            scale: 1.08,
            color: '#E8CA6B'
          }} animate={{
            scale: 1,
            color: '#D4AF37'
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 20
          }} data-id="element-134">
              <p className="text-5xl md:text-7xl font-bold text-gold mb-4" data-id="element-135">
                HOY SOLO: ${total.toFixed(2)}{' '}
                <span className="text-2xl md:text-3xl" data-id="element-136">USD</span>
              </p>
            </motion.div>
            <p className="text-white/60 italic text-lg" data-id="element-137">
              (Pago único. Acceso inmediato de por vida.)
            </p>
            <AnimatePresence data-id="element-138">
              {(bump1 || bump2) && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} className="mt-3 text-sm text-white/50" data-id="element-139">
                  Blueprint ${basePrice.toFixed(2)}
                  {bump1 && <span data-id="element-140"> + Escudo Espiritual ${bump1Price.toFixed(2)}</span>}
                  {bump2 && <span data-id="element-141"> + Buscador de Oro ${bump2Price.toFixed(2)}</span>}
                </motion.div>}
            </AnimatePresence>
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-142">
            <Button href={checkoutUrl} onClick={() => {
            const items = ['Emprender con Unción Blueprint'];
            if (bump1) items.push('Escudo Espiritual');
            if (bump2) items.push('El Buscador de Oro');
            trackAddToCart(total, items);
          }} className="w-full md:w-auto md:px-12 md:py-6 text-xl md:text-2xl" data-id="element-143">
              ⚡ SÍ, QUIERO EMPRENDER CON UNCIÓN — ACCESO INMEDIATO POR $
              {total.toFixed(2)}
            </Button>

            {/* ORDER BUMP #1 */}
            <motion.div initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="w-full max-w-2xl relative" data-id="element-144">
              {/* Shimmer flash effect */}
              <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none z-10" data-id="element-145">
                <div className="bump-shimmer" data-id="element-146" />
              </div>
              <div onClick={() => setBump1(!bump1)} className={`
                  cursor-pointer rounded-xl border-2 border-dashed border-gold 
                  bg-[#FFFBEB] p-5 md:p-6 text-left transition-all duration-300 relative
                  ${bump1 ? 'ring-2 ring-gold shadow-lg shadow-gold/20' : 'hover:shadow-md'}
                `} data-id="element-147">
                <div className="flex items-start gap-4" data-id="element-148">
                  <div className="flex-shrink-0 mt-1" data-id="element-149">
                    <div className={`w-6 h-6 rounded border-2 flex items-center justify-center transition-colors ${bump1 ? 'bg-gold border-gold' : 'border-gray-400 bg-white'}`} data-id="element-150">
                      {bump1 && <svg className="w-4 h-4 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-151">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-152" />
                        </svg>}
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-153">
                    <h3 className="font-montserrat font-bold text-navy text-lg md:text-xl mb-3" data-id="element-154">
                      🛡️ SÍ, QUIERO EL ESCUDO ESPIRITUAL (SOLO $9.90)
                    </h3>
                    <div className="flex flex-col md:flex-row gap-4" data-id="element-155">
                      <img src="https://cdn.magicpatterns.com/uploads/cHj1hFY5QQcRmDNkQ2yz5i/Portada_Order_Bump_1.png" alt="Escudo Espiritual Diario" className="w-full md:w-32 h-auto rounded-lg object-cover flex-shrink-0" data-id="element-156" />
                      <div data-id="element-157">
                        <p className="text-navy/80 text-sm md:text-base leading-relaxed mb-3" data-id="element-158">
                          No salgas al mercado sin tu armadura. Blindar tu mente
                          y tu negocio cada mañana es la diferencia entre el
                          cansancio y la victoria. Esta guía digital de acceso
                          inmediato contiene las{' '}
                          <strong className="text-navy" data-id="element-159">
                            21 declaraciones de poder y oraciones de autoridad
                          </strong>{' '}
                          diseñadas específicamente para el emprendedor hispano
                          en EE.UU. Configura tu espíritu para la abundancia,
                          protege tus decisiones y rompe con todo ciclo de
                          escasez antes de empezar a trabajar.
                        </p>
                        <p className="text-sm font-semibold text-navy" data-id="element-160">
                          ☑️ Selecciona la casilla para añadirlo a tu orden por
                          solo <span className="text-gold-hover" data-id="element-161">$9.90</span>{' '}
                          <span className="text-navy/50 line-through text-xs" data-id="element-162">
                            (Precio regular $47)
                          </span>{' '}
                          <span className="text-green-700 font-bold" data-id="element-163">
                            — ¡Ahorras un 80%!
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* ORDER BUMP #2 */}
            <motion.div initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.35
          }} className="w-full max-w-2xl relative" data-id="element-164">
              {/* Shimmer flash effect */}
              <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none z-10" data-id="element-165">
                <div className="bump-shimmer bump-shimmer-delay" data-id="element-166" />
              </div>
              <div onClick={() => setBump2(!bump2)} className={`
                  cursor-pointer rounded-xl border-2 border-solid border-navy-light 
                  bg-[#F9FAFB] p-5 md:p-6 text-left transition-all duration-300 relative
                  ${bump2 ? 'ring-2 ring-navy shadow-lg shadow-navy/20' : 'hover:shadow-md'}
                `} data-id="element-167">
                <div className="flex items-start gap-4" data-id="element-168">
                  <div className="flex-shrink-0 mt-1" data-id="element-169">
                    <div className={`w-6 h-6 rounded border-2 flex items-center justify-center transition-colors ${bump2 ? 'bg-navy border-navy' : 'border-gray-400 bg-white'}`} data-id="element-170">
                      {bump2 && <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-171">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-172" />
                        </svg>}
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-173">
                    <h3 className="font-montserrat font-bold text-navy text-lg md:text-xl mb-3" data-id="element-174">
                      🔎 AÑADIR: "EL BUSCADOR DE ORO" — 50 NICHOS RENTABLES
                      ($17.00)
                    </h3>
                    <div className="flex flex-col md:flex-row gap-4" data-id="element-175">
                      <img src="https://cdn.magicpatterns.com/uploads/rUFEwNDKct4TEB6XYYHwRm/Portada_Order_Bump_2.png" alt="El Buscador de Oro - 50 Nichos Rentables" className="w-full md:w-32 h-auto rounded-lg object-cover flex-shrink-0" data-id="element-176" />
                      <div data-id="element-177">
                        <p className="text-navy/80 text-sm md:text-base leading-relaxed mb-3" data-id="element-178">
                          ¿Aún no sabes exactamente qué negocio empezar? He
                          analizado el mercado americano por ti y seleccioné los{' '}
                          <strong className="text-navy" data-id="element-179">
                            50 Micro-Nichos de baja inversión y alta
                            rentabilidad
                          </strong>{' '}
                          para nuestra comunidad en 2026. Ve directo a donde
                          está el flujo de efectivo sin perder meses adivinando.
                          Incluye inversión estimada, demanda por estado y
                          facilidad de escala.
                        </p>
                        <p className="text-sm font-semibold text-navy" data-id="element-180">
                          ☑️ Selecciona la casilla para añadirlo a tu orden por
                          solo <span className="text-gold-hover" data-id="element-181">$17.00</span>.{' '}
                          <span className="text-navy/50 italic text-xs" data-id="element-182">
                            (Oferta única válida solo al adquirir el Blueprint
                            hoy)
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Dynamic total summary */}
            <AnimatePresence data-id="element-183">
              {(bump1 || bump2) && <motion.div initial={{
              opacity: 0,
              y: -10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} className="w-full max-w-2xl bg-white/10 border border-gold/30 rounded-xl p-4 text-center" data-id="element-184">
                  <p className="text-white/70 text-sm mb-1" data-id="element-185">
                    Tu orden incluye:
                  </p>
                  <div className="space-y-1 text-white/80 text-sm" data-id="element-186">
                    <p data-id="element-187">
                      📖 Blueprint Emprender con Unción — $
                      {basePrice.toFixed(2)}
                    </p>
                    {bump1 && <p data-id="element-188">🛡️ Escudo Espiritual — ${bump1Price.toFixed(2)}</p>}
                    {bump2 && <p data-id="element-189">🔎 El Buscador de Oro — ${bump2Price.toFixed(2)}</p>}
                  </div>
                  <div className="mt-3 pt-3 border-t border-white/20" data-id="element-190">
                    <p className="text-gold font-bold text-xl" data-id="element-191">
                      TOTAL: ${total.toFixed(2)} USD
                    </p>
                  </div>
                  <Button href={checkoutUrl} onClick={() => {
                const items = ['Emprender con Unción Blueprint'];
                if (bump1) items.push('Escudo Espiritual');
                if (bump2) items.push('El Buscador de Oro');
                trackAddToCart(total, items);
              }} className="w-full mt-4 py-5 text-xl md:text-2xl" data-id="element-192">
                    🛒 COMPLETAR COMPRA — ${total.toFixed(2)} USD
                  </Button>
                </motion.div>}
            </AnimatePresence>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-white/50" data-id="element-193">
              <div className="flex items-center gap-2" data-id="element-194">
                <Lock className="w-4 h-4" data-id="element-195" />
                <span data-id="element-196">Pago 100% Seguro con SSL</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-197">
                <ShieldCheck className="w-4 h-4" data-id="element-198" />
                <span data-id="element-199">Garantía de Devolución de 7 Días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-200">
                <Download className="w-4 h-4" data-id="element-201" />
                <span data-id="element-202">Descarga Inmediata al Email</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}